import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import initializeAOS from "../utils/aosLibrary";
import dot2_vector from "../assets/dot2-vector.svg";
import dot3_vector from "../assets/dot3-vector.svg";
import line_3 from "../assets/new_line_vector.svg";
import line_vector from "../assets/line3-vector.svg";
import arrow_new from "../assets/Arrow_service.svg";
import vector4 from "../assets/vector-4.svg";
import contactimg from "../assets/customer-service-handsome-guy-with-headset-laptop-suit-taking-down-notes-01.png";
import EnouthTalk from "../Components/EnouthTalk";
import { useMediaQuery } from "@mui/material";
import axios from "axios";
import baseUrl from "../config";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../loader";
import { useTranslation } from "react-i18next";

function ContactUs() {
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
  const { t } = useTranslation();
  const [firstName, setFirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  const notify = (message) => toast.success(message);
  const handlesubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formdata = new FormData();
    formdata.append("full_name", `${firstName} ${lastName}`);
    formdata.append("email", email);
    formdata.append("phone", phoneNumber);
    formdata.append("descriptions", message);

    try {
      const response = await axios.post(
        `${baseUrl}/contact_request.php`,
        formdata
      );
      console.log(response);
      if (response.data.success === true) {
        setLoading(false);
        notify("Your message has been sent successfully");
        setTimeout(() => {
          navigate("/");
        }, 2500);
      }
    } catch (err) { }
  };
  const fontLivic = "Livvic , sans-serif";
  useEffect(() => {
    document.title =
      "Contact Us | Fundnest – Get in Touch for Tailored IT Services & Solutions";
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Have questions or need assistance? Contact Fundnest to learn how our customized IT services and cloud solutions can help your business grow. We're here to support you!"
    );
    initializeAOS();
  }, []);

  return (
    <>
      <Navbar />
      <div
        style={{
          height: "300px",
          background:
            "linear-gradient(105deg, rgba(244, 236, 194, .6) 1.74%, rgba(228, 250, 242, .6) 39.85%, rgba(211, 243, 207, .6) 73.94%, rgba(255, 243, 228, .6) 98.01%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <h1
            data-aos="fade-up"
            style={{
              fontSize: isXs ? "64px" : "50px",
              lineHeight: "1.15",
              letterSpacing: "0.67px",
              fontWeight: "bold",
              fontWeight: "700",
              textAlign: isXs ? "" : "center",
            }}
          >
            {t('contactUs.heading')}
          </h1>
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="3000"
          style={{
            color: "black",
            fontFamily: fontLivic,
            fontSize: "18px",
            textAlign: "center",
            width: isXs ? "" : "80%",
            maxWidth: "500px"
          }}
        >
          {t('contactUs.headline')}
        </div>
        <img
          src={arrow_new}
          loading="lazy"
          alt="Hero Shape Image"
          className="hero-shape-2"
          style={{
            display: isXs ? "flex" : "none",
            animation: "moveUpDown 1.5s infinite alternate",
            position: "absolute",
            top: "180px",
            left: "87px",
            zIndex: "5",
          }}
        />
        <img
          style={{
            display: isXs ? "flex" : "none",
            position: "absolute",
            right: "0",
            top: "200px",
          }}
          src={line_vector}
          alt=""
        />
      </div>

      <div
        style={{
          display: "flex",
          height: isXs ? "800px" : "",
          padding: isXs ? "90px 60px" : "90px 30px",
          flexDirection: isXs ? "" : "column-reverse",
          marginTop: isXs ? "" : "10px",
        }}
      >
        <div
          data-aos=""
          style={{
            width: isXs ? "50%" : "100%",
            position: "relative",
            paddingTop: "50px",
          }}
        >
          <div
            data-aos="fade-down-right"
            style={{ zIndex: "1", width: "215px", height: "215px" }}
          >
            <img
              style={{
                objectFit: "cover",
                height: "100%",
                width: "100%",
                display: isXs ? "flex" : "none",
              }}
              src={vector4}
              alt=""
            />
          </div>
          <div
            data-aos="fade-up-left"
            style={{
              position: "absolute",
              top: isXs ? "30px" : "20px",
              left: isXs ? "30px" : "0px",
              height: isXs ? "500px" : "350px",
              width: isXs ? "500px" : "",
            }}
          >
            <img
              style={{ objectFit: "contain", height: "100%", width: "100%" }}
              src={contactimg}
              alt=""
            />
          </div>
        </div>
        <div style={{ width: isXs ? "50%" : "100%" }}>
          <div
            data-aos="fade-up"
            style={{
              backgroundColor: "#F1F1F1",
              borderRadius: "25px",
              minWidth: "220px",
              width: "fit-content",
              maxWidth: "320px",
              padding: "10px 20px",
              fontSize: "18px",
              textAlign: "center",
              fontWeight: "400",
              color: "black",
              marginBottom: "40px",
            }}
          >
            {t('contactUs.section', { returnObjects: true })[0]['button']}
          </div>
          <h2
            data-aos="fade-left"
            style={{
              letterSpacing: isXs ? "-2px" : "1",
              fontSize: "48px",
              fontWeight: "700",
              lineHeight: "1.25",
            }}
          >
            {t('contactUs.section', { returnObjects: true })[0]['heading']}
          </h2>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div style={{ display: "flex", gap: "10px", alignItems: "start" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  data-aos="fade-up"
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                    marginTop: "20px",
                  }}
                >
                  {t('contactUs.section', { returnObjects: true })[0]['description']}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: "30px",
                flexDirection: isXs ? "row" : "column",
              }}
            >
              <div data-aos="fade-up" style={{ width: "100%" }}>
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    marginBottom: "10px",
                  }}
                >
                  {t('contactUs.section', { returnObjects: true })[0]['address']['title']}
                </div>
                <div
                  style={{
                    fontFamily: fontLivic,
                    fontSize: "18px",
                    width: isXs ? "100%" : "100%",
                  }}
                >
                  {t('contactUs.section', { returnObjects: true })[0]['address']['address']}

                </div>
              </div>
              <div data-aos="fade-up" style={{ width: "100%" }}>
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    marginBottom: "10px",
                  }}
                >
                  {t('contactUs.section', { returnObjects: true })[0]['callUs']['title']}
                </div>
                <div style={{ fontFamily: fontLivic, fontSize: "18px" }}>
                  +91 XXXXX XXXXX
                </div>
              </div>
            </div>
            <div data-aos="fade-up" style={{ width: "100%" }}>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  marginBottom: "10px",
                }}
              >
                {t('contactUs.section', { returnObjects: true })[0]['email']['title']}
              </div>
              <a
                href="mailto:connect@fundnest.in"
                style={{
                  fontFamily: fontLivic,
                  fontSize: "18px",
                  textDecoration: "none",
                  color: "black",
                }}
              >
                connect@fundnest.in
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Contact form Section */}

      <div
        data-aos="fade-up"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: isXs ? "0" : "20px 10px",
          textAlign: isXs ? "center" : "",
        }}
      >
        <div
          style={{
            fontSize: isXs ? "48px" : "40px",
            lineHeight: "1.15",
            letterSpacing: "-0.64px",
            fontWeight: "bold",
            fontWeight: "700",
            marginBottom: "30px",
            textAlign: isXs ? "" : "center",
          }}
        >
          {t('contactUs.section', { returnObjects: true })[1]['heading']}
        </div>
        <div
          style={{
            color: "black",
            fontFamily: fontLivic,
            fontSize: "18px",
            textAlign: "center",
            marginBottom: "30px",
            maxWidth: "60%"
          }}
        >
          {t('contactUs.section', { returnObjects: true })[1]['content']}
        </div>
      </div>

      <form onSubmit={handlesubmit}>
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          style={{
            display: "flex",
            flexDirection: "column",
            padding: isXs ? "20px 200px" : "20px 30px",
            gap: "30px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "30px",
              flexDirection: isXs ? "row" : "column",
            }}
          >
            <input
              onChange={(e) => setFirstName(e.target.value)}
              style={{
                borderRadius: "40px",
                width: "100%",
                fontFamily: fontLivic,
                height: "70px",
                paddingLeft: "20px",
                border: "1px solid black",
              }}
              type="text"
              placeholder={t('contactUs.section', { returnObjects: true })[1]['form']['fname']}
              required
            />
            <input
              onChange={(e) => setlastName(e.target.value)}
              style={{
                borderRadius: "40px",
                width: "100%",
                fontFamily: fontLivic,
                height: "70px",
                paddingLeft: "20px",
                border: "1px solid black",
              }}
              type="text"
              placeholder={t('contactUs.section', { returnObjects: true })[1]['form']['lname']}
              required
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "30px",
              flexDirection: isXs ? "row" : "column",
            }}
          >
            <input
              onChange={(e) => setEmail(e.target.value)}
              style={{
                borderRadius: "40px",
                width: "100%",
                fontFamily: fontLivic,
                height: "70px",
                paddingLeft: "20px",
                border: "1px solid black",
              }}
              type="email"
              placeholder={t('contactUs.section', { returnObjects: true })[1]['form']['email']}
              required
            />
            <input
              onChange={(e) => setPhoneNumber(e.target.value)}
              style={{
                borderRadius: "40px",
                width: "100%",
                fontFamily: fontLivic,
                height: "70px",
                paddingLeft: "20px",
                border: "1px solid black",
              }}
              type="tel"
              placeholder={t('contactUs.section', { returnObjects: true })[1]['form']['phone']}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9+]/g, '').replace(/(?!^)\+/g, '')

              }
              maxLength={15}
              required
            />
          </div>
          <textarea
            onChange={(e) => setMessage(e.target.value)}
            style={{
              borderRadius: "40px",
              fontFamily: fontLivic,
              paddingLeft: "20px",
              paddingTop: "25px",
              height: "250px",
              border: "1px solid black",
            }}
            type="text"
            placeholder={t('contactUs.section', { returnObjects: true })[1]['form']['textarea']}
            required
          />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              type="submit"
              style={{
                backgroundColor: "#512CEB",
                color: "white",
                fontSize: "18px",
                fontWeight: "600",
                borderRadius: "30px",
                minWidth: "140px",
                width: "fit-content",
                maxWidth: "240px",
                border: "none",
                padding: "10px 20px",
                textAlign: "center",
              }}
            >
              {loading ? <Loader /> : t('contactUs.section', { returnObjects: true })[1]['form']['button']}
            </button>
          </div>
        </div>
      </form>

      <EnouthTalk />
      <Footer />
      <ToastContainer
        position="top-right" // You can change the position
        autoClose={2000} // You can change the auto close time
        padding="15px"
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default ContactUs;
